// extracted by mini-css-extract-plugin
module.exports = {"MenuSection":"MenuSection_MenuSection__1OCe_"};